$(document).ready(function() {

	$('.pci-home-page-header-slideshow').each(function(index, slideshow) {
		var arrows = ($(slideshow).attr('data-arrows') === 'true');
		var autoplay = ($(slideshow).attr('data-autoplay') === 'true');
		if (autoplay === true) {
			autoplay = $(slideshow).attr('data-autoplay-speed');
		}
		console.log('autoplay', autoplay);
		var slideshow = $(slideshow).flickity({
			autoPlay: autoplay,
			cellAlign: 'left',
			contain: true,
			draggable: false,
			pauseAutoPlayOnHover: false,
			prevNextButtons: arrows,
			pageDots: false,
			wrapAround: true
		});
	});


	// search form functionality
	if ($('body').hasClass('page-template-page-pci-home')) {
		autocomplete();
		initialSearchForm();
	}

	// breeze video modals
	$('.pci-breeze-video').on('click', function(e) {
		e.preventDefault();
		var video_id = $(this).attr('data-video-id');
		if (video_id) {
			$('body').addClass('pci-modal-active');
			var template = $($('#pci-breeze-video-modal-template').html());
			var video_url = 'https://www.youtube.com/embed/' + video_id;
			console.log(video_url);
			$('iframe', template).attr('src', video_url);
			$('body').append(template);
		}
	});

	// toggle team member biography
	$('.pci-team-member').on('click', function(e) {
		e.preventDefault();
		var trigger = $(this);
		$(trigger).prop('disabled', true);
		$('body').addClass('pci-modal-active');
		var teamMemberId = $(this).attr('data-id');
		$.ajax({
			type: 'post',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'pci_get_team_member_details',
				teamMemberId: teamMemberId
			},
			success: function(results) {
				var results = JSON.parse(results);
				console.log(results);
				if (results.status == 'success') {
					var template = $($('#pci-team-member-modal-template').html());
					if (results.id) {
						$(template).attr('data-id', results.id);
					}
					if (results.name) {
						$('.pci-modal-title', template).html(results.name);
					}
					if (results.job_title) {
						$('.pci-modal-subtitle', template).html(results.job_title);
					}
					if (!results.phone_number && !results.email_address) {
						$('.pci-team-member-modal-phone', template).hide();
					}
					if (results.phone_number) {
						$('.pci-team-member-modal-phone', template).attr({
							'href': 'tel:' + results.phone_number,
							'title': 'Call ' + results.name
						}).html(results.phone_number);
					} else {
						$('.pci-team-member-modal-phone', template).hide();
					}
					if (results.email_address) {
						$('.pci-team-member-modal-email', template).attr({
							'href': 'mailto:' + results.email_address,
							'title': 'Email ' + results.name
						}).html(results.email_address);
					} else {
						$('.pci-team-member-modal-email', template).hide();
					}
					if (results.biography) {
						$('.pci-modal-text', template).html(results.biography);
					}
					if (results.image) {
						$('.pci-modal-image img', template).attr({
							'src': results.image.sizes['pci-team-member-large-1x'],
							'srcset': results.image.sizes['pci-team-member-large-1x'] + ', ' + results.image.sizes['pci-team-member-large-2x'] + ' 2x',
							'alt': results.image.alt
						});
					}
					$('body').append(template);
				} else {
					alert('Something went wrong. Try again?');
				}
				$(trigger).prop('disabled', false);
			},
			error: function(results) {
				var results = JSON.parse(results);
				console.log(results);
				$(this).prop('disabled', false);
				$('body').removeClass('pci-modal-active');
			}
		});
	});

	// close modal window
	$('body').on('click', '.pci-modal-close', function(e) {
		e.preventDefault();
		if ($(this).is('#pci-promo-modal-close')) {
			var right_now = moment.utc();
			var expiration_date = moment.utc(right_now).add(1, 'week');
			console.log('right now:', moment(right_now).toString());
			console.log('one week from now:', moment(expiration_date).toString());
			document.cookie = 'hide_promo_modal=true;expires=' + moment(expiration_date).toString() + ';secure';
		}
		var thisModal = $(this).parents('.pci-modal');
		$(thisModal).remove();
		$('body').removeClass('pci-modal-active');
	})

	// accordion functionality
	$('.pci-accordion-item').each(function() {
		$('.pci-accordion-item-title').click(function() {
			$(this).parents('.pci-accordion-item').toggleClass('pci-accordion-item-active');
		});
	});

	// testimonials slider
	if ($('.pci-testimonial').length > 3) {
		var testimonials_slider = $('.pci-testimonials-group').flickity({
			adaptiveHeight: false,
			cellAlign: 'left',
			contain: true,
			pageDots: false,
			percentPosition: true,
			wrapAround: true
		});
	}

	// newsletter sign-up form
	$('#pci-newsletter-form').validate({
		// debug: true,
		errorElement: 'span',
		errorClass: 'form-field-error',
		validClass: 'form-field-valid',
		errorPlacement: function (error, element) {
			error.appendTo(element.parents('.form-field'));
		},
		highlight: function (element, errorClass, validClass) {
			$(element).parent('.form-field').addClass(errorClass).removeClass(validClass);
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).parent('.form-field').removeClass(errorClass).addClass(validClass);
		},
		rules : {
			'pci-newsletter-email': {
				required: true,
				email: true
			}
		},
		messages: {
			'pci-newsletter-email': {
				required: 'Please enter your email address.',
				email: 'Please enter a valid email address.'
			}
		},
		submitHandler(form) {

			$('.button-spinner').prop('disabled', true);

			var email = $('#pci-newsletter-email').val();
			var nonce = $('#pci-newsletter-form-nonce').val();

			$.ajax({
				type: 'post',
				url: '/wp-admin/admin-ajax.php',
				data: {
					action: 'pci_newsletter_form',
					email: email,
					nonce: nonce
				},
				success: function(results) {
					var results = $.parseJSON(results);
					console.log(results);
					if (results.status == 'success') {
						$('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
					} else {
						$('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
					}
					$('.button-spinner').prop('disabled', false);
				},
				error: function(results) {
					var results = $.parseJSON(results);
					console.log(results);
					$('.button-spinner').prop('disabled', false);
					$('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
				}
			});

		}
	});

	// contact form
	$('#pci-contact-form').validate({
		debug: true,
		errorElement: 'span',
		errorClass: 'form-field-error',
		validClass: 'form-field-valid',
		errorPlacement: function (error, element) {
			error.appendTo(element.parents('.form-field'));
		},
		highlight: function (element, errorClass, validClass) {
			$(element).parent('.form-field').addClass(errorClass).removeClass(validClass);
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).parent('.form-field').removeClass(errorClass).addClass(validClass);
		},
		rules: {
			'name': {
				required: true,
				minlength: 2
			},
			'email': {
				required: true,
				email: true
			},
			'phone-number': {
				// required: true,
				phoneUS: true
			},
			'message': {
				required: true,
				minlength: 2
			}
		},
		messages: {
			'name': {
				required: 'Please enter your name.',
				minlength: 'Your name must be at least 2 characters long.'
			},
			'email': {
				required: 'Please enter your email address.',
				email: 'Please enter a valid email address.'
			},
			'phone-number': {
				phoneUS: 'Please enter a valid telephone number.'
			},
			'message': {
				required: 'Please explain how we can help you.',
				minlength: 'Your message must be at least 2 characters long.'
			}
		},
		submitHandler(form) {
			$('.button-spinner').prop('disabled', true);

			var name = $('#name').val();
			var email = $('#email').val();
			var phoneNumber = $('#phone-number').val();
			var message = $('#message').val();
			var nonce = $('#pci-contact-form-nonce').val();

			$.ajax({
				type: 'post',
				url: '/wp-admin/admin-ajax.php',
				data: {
					action: 'pci_contact_form',
					name: name,
					email: email,
					phoneNumber: phoneNumber,
					message: message,
					nonce: nonce
				},
				success: function(results) {
					var results = $.parseJSON(results);
					console.log(results);
					$('.button-spinner').prop('disabled', false);
					$('.form-card-message', form).removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
				},
				error: function(results) {
					var results = $.parseJSON(results);
					console.log(results);
					$('.button-spinner').prop('disabled', false);
					$('.form-card-message', form).removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
				}
			});
		}
	});

	// request for proposal form
	$('#pci-proposal-form').validate({
		// debug: true,
		errorElement: 'span',
		errorClass: 'form-field-error',
		validClass: 'form-field-valid',
		errorPlacement: function (error, element) {
			error.appendTo(element.parents('.form-field'));
		},
		highlight: function (element, errorClass, validClass) {
			$(element).parent('.form-field').addClass(errorClass).removeClass(validClass);
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).parent('.form-field').removeClass(errorClass).addClass(validClass);
		},
		rules: {
			'venue': {
				required: true
			},
			'name': {
				required: true,
				minlength: 2
			},
			'email': {
				required: true,
				email: true
			},
			'phone-number': {
				// required: true,
				phoneUS: true
			},
			'company': {
				required: true,
				minlength: 2
			},
			'city': {
				required: true,
				minlength: 2
			},
			'state': {
				required: true
			},
			'message': {
				required: true,
				minlength: 2
			}
		},
		messages: {
			'venue': {
				required: 'Please select a venue.'
			},
			'name': {
				required: 'Please enter your name.',
				minlength: 'Your name must be at least 2 characters long.'
			},
			'email': {
				required: 'Please enter your email address.',
				email: 'Please enter a valid email address.'
			},
			'phone-number': {
				phoneUS: 'Please enter a valid telephone number.'
			},
			'company': {
				required: 'Please enter the management company name.',
				minlength: 'Please enter a name longer than 2 characters.'
			},
			'city': {
				required: 'Please enter your city.',
				minlength: 'Please enter a city name longer than 2 characters.'
			},
			'state': {
				required: 'Please choose your state.'
			},
			'message': {
				required: 'Please explain how we can help you.',
				minlength: 'Your message must be at least 2 characters long.'
			}
		},
		submitHandler(form) {
			$('.button-spinner').prop('disabled', true);

			var venue = $('#venue').val();
			var name = $('#name').val();
			var email = $('#email').val();
			var phoneNumber = $('#phone-number').val();
			var company = $('#company').val();
			var city = $('#city').val();
			var state = $('#state').val();
			var message = $('#message').val();
			var nonce = $('#pci-proposal-form-nonce').val();

			$.ajax({
				type: 'post',
				url: '/wp-admin/admin-ajax.php',
				data: {
					action: 'pci_proposal_form',
					venue: venue,
					name: name,
					email: email,
					phoneNumber: phoneNumber,
					company: company,
					city: city,
					state: state,
					message: message,
					nonce: nonce
				},
				success: function(results) {
					var results = $.parseJSON(results);
					console.log(results);
					$('.button-spinner').prop('disabled', false);
					$('.form-card-message', form).removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
				},
				error: function(results) {
					var results = $.parseJSON(results);
					console.log(results);
					$('.button-spinner').prop('disabled', false);
					$('.form-card-message', form).removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
				}
			});
		}
	});

	$('#open-search-modal').on('click', function(e) {
		e.preventDefault();
		$('body').addClass('pci-modal-active');
		$('#pci-search-modal').addClass('pci-search-modal-active');
	});

	$('.pci-search-modal-close').on('click', function(e) {
		e.preventDefault();
		$('#pci-search-modal').removeClass('pci-search-modal-active');
		$('body').removeClass('pci-modal-active');
	});

	// close modal on ESC key press
	$(document).on('keydown', function(e) {
		if (e.keyCode === 27) {
			$('#pci-search-modal').removeClass('pci-search-modal-active');
			$('body').removeClass('pci-modal-active');
		}
	});

	// $('#pci-search-form').on('submit', function(e) {
	// 	e.preventDefault();
	// });

});
